
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Security() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to VSL Cloaker for backward compatibility
    navigate("/vsl-cloaker", { replace: true });
  }, [navigate]);

  return null;
}
